import { useEffect, useRef } from "react";
import { api } from "@/lib/api";

const MANUAL = new Set(["On Leave", "In Meeting"]);

export function useAvailabilityTracker(user, refresh) {
  const lastSent = useRef(null);

  useEffect(() => {
    if (!user || user.role === "Client") return;
    const send = (status) => {
      if (MANUAL.has(user.availability_status)) return; // don't override manual
      if (lastSent.current === status) return;
      lastSent.current = status;
      api.patch("/auth/me/status", { availability_status: status }).then(() => refresh && refresh()).catch(() => {});
    };
    const onVisibility = () => {
      if (document.visibilityState === "visible") send("Available Now");
      else send("Online");
    };
    const onFocus = () => send("Available Now");
    const onBlur = () => send("Online");
    const onUnload = () => {
      if (MANUAL.has(user.availability_status)) return;
      try {
        const body = JSON.stringify({ availability_status: "Not Available" });
        const url = (process.env.REACT_APP_BACKEND_URL || "") + "/api/auth/me/status";
        const token = localStorage.getItem("fms_token");
        // sendBeacon can't set Authorization; use fetch with keepalive
        fetch(url, { method: "PATCH", body, keepalive: true, credentials: "include",
          headers: { "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) } });
      } catch {}
    };
    // Initial
    send(document.visibilityState === "visible" ? "Available Now" : "Online");
    document.addEventListener("visibilitychange", onVisibility);
    window.addEventListener("focus", onFocus);
    window.addEventListener("blur", onBlur);
    window.addEventListener("beforeunload", onUnload);
    window.addEventListener("pagehide", onUnload);
    return () => {
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("focus", onFocus);
      window.removeEventListener("blur", onBlur);
      window.removeEventListener("beforeunload", onUnload);
      window.removeEventListener("pagehide", onUnload);
    };
  }, [user?.id, user?.availability_status, refresh]);
}
